import { useApp } from "common/AppContext";
import React from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";

const FleetDropdownFilter = ({ value, onChange }) => {

    const { fleets } = useApp();

    return (
        <Form.Select
            value={value}
            onChange={e => onChange(e.target.value)}
            >
            <option value="">All Fleets</option>
            {fleets.map(fleet => (
                <option key={fleet.appstream_fleet_name} value={fleet.appstream_fleet_name}>
                    {fleet.name}
                </option>
                        ))}
        </Form.Select>
    );
};

export default FleetDropdownFilter;
